import NextLink from 'next/link';
import React from 'react';
import {
  cleanAsAlias,
  cleanNextRoute
} from '../../functions/primitiveHelpers/routerHelpers';
import { IChildrenProps } from '../../models/utilTypes';

interface INextLinkWrapperProps extends IChildrenProps {
  href: string;
  as?: string;
  prefetch?: boolean;
}

// very explicit name to help with debugging
const NextLinkWrapper: React.FC<INextLinkWrapperProps> = ({
  href,
  as,
  children,
  prefetch = false
}) => {
  const attributes = {
    passHref: true,
    href: cleanNextRoute(href),
    as: cleanAsAlias(as || href),
    prefetch: !!prefetch
  };

  return <NextLink {...attributes}>{children}</NextLink>;
};

export default NextLinkWrapper;
